import { Component, Input } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { PreviewItemContextMenuComponet } from "../preview-item-context-menu.component";
import { PreviewItem } from "@apiserver-rest/ponder-data-client-base";

@Component({
    selector: "preview-item-context-add-to-deck",
    imports: [],
    templateUrl: "./preview-item-context-menu-add-to-deck.component.html"
})
export class PreviewItemContextMenuAddToDeck {
    @Input({ required: true }) parentRef!: PreviewItemContextMenuComponet;
    @Input({ required: true }) previewItem!: PreviewItem;

    public readonly svgIcon: string = SvgIconMap.get(SvgIcon.Decks)!;

    public constructor(private events: EventBroker) {

    }

    public onClick(): void {
        var event = {
            game: this.previewItem.game!,
            name: this.previewItem.name!,
            itemId: this.previewItem.id!,
            hasNormal: true,
            hasSpecial: true
        };

        if (this.previewItem.data?.magic) {
            event.hasNormal = this.previewItem.data.magic.treatment.normal;
            event.hasSpecial = this.previewItem.data.magic.treatment.special;
        }

        this.events.deck.showAddCardToDecksModalEvent.emit(event);

        this.parentRef.onClose();
    }
}